import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Grid,
    CircularProgress,
    Typography,
} from "@mui/material";
import dayjs from "dayjs";



import { useNavigate } from "react-router-dom";
import { OffersRoutes } from "../../../../Router/path";
import { useCreateAutomaticBookingsMutation } from "../../../Bookings/Service/extendedBookingsApi";
import { AutomaticBookingsDialogProps } from "./AutomaticBookingsDialog.types";



const AutomaticBookingsDialog = ({
    offerId,
    open,
    onClose,
    onSuccess,

}: AutomaticBookingsDialogProps) => {
    const [createAutomaticBookings, { isLoading }] = useCreateAutomaticBookingsMutation();
    const [bookingParams, setBookingParams] = useState({
      startDate: dayjs().format('YYYY-MM-DD'),
      durationInDays: '3',
      offsetDays: '2',
      numberOfBookings: '10',
    });
    const navigate = useNavigate();

    const durationInDays = Number.parseInt(bookingParams.durationInDays, 10);
    const offsetDays = Number.parseInt(bookingParams.offsetDays, 10);
    const numberOfBookings = Number.parseInt(bookingParams.numberOfBookings, 10);

    const isFormValid =
      Number.isInteger(durationInDays) &&
      durationInDays > 0 &&
      Number.isInteger(offsetDays) &&
      Number.isInteger(numberOfBookings) &&
      numberOfBookings > 0;

    const handleAutomaticBookings = async () => {
      if (!isFormValid) {
        return;
      }

      await createAutomaticBookings({
        offerId,
        startDate: bookingParams.startDate,
        durationInDays,
        offsetDays,
        numberOfBookings,
        numberOfParticipants: 0,
        price: 0,
        published: false,
        bookingStatusName: '',
        possibilityOfReservation: false,
        id: 0,
      }).unwrap();
      onClose();
      if (onSuccess) onSuccess();
      else navigate(OffersRoutes.root);
    };

    const handleClose = () => {
      onClose();
      if (onSuccess) onSuccess();
      else navigate(OffersRoutes.root);
    };

    return (
      <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle>Automatyczne rezerwacje</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid size={{ xs: 12 }}>
              <TextField
                label="Data startu"
                type="date"
                value={bookingParams.startDate}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setBookingParams((prev) => ({ ...prev, startDate: e.target.value }))
                }
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                label="Czas trwania (dni)"
                type="number"
                value={bookingParams.durationInDays}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setBookingParams((prev) => ({
                    ...prev,
                    durationInDays: e.target.value,
                  }))
                }
                inputProps={{ min: 1 }}
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                label="Odstęp między rezerwacjami (dni)"
                type="number"
                value={bookingParams.offsetDays}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setBookingParams((prev) => ({
                    ...prev,
                    offsetDays: e.target.value,
                  }))
                }
                inputProps={{ step: 1 }}
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                label="Liczba rezerwacji"
                type="number"
                value={bookingParams.numberOfBookings}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setBookingParams((prev) => ({
                    ...prev,
                    numberOfBookings: e.target.value,
                  }))
                }
                inputProps={{ min: 1 }}
                fullWidth
              />
            </Grid>
          </Grid>
          {isLoading && (
            <Typography align="center" sx={{ mt: 2 }}>
              <CircularProgress />
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Anuluj</Button>
          <Button
            onClick={handleAutomaticBookings}
            variant="contained"
            color="primary"
            disabled={isLoading || !isFormValid}
          >
            Utwórz rezerwacje
          </Button>
        </DialogActions>
      </Dialog>
    );
};
export default AutomaticBookingsDialog;